// TODO: Import React module
import * as React from 'react';

// TODO: Import MUI module
import { Box, Stack, Typography, } from '@mui/material';

// TODO: Import MUI icon
import { } from '@mui/icons-material';

// TODO: Import context
import { Context } from '../../Common/Context';
import { Text } from '../../Common/Text';

// TODO: Import custom component
import Slide from '../Slide_LT.jpg';

import BoxSubPage from '../../Common/BoxSubPage';
import BoxImage from '../../Common/BoxImage';
import DialogVideo from '../../Common/DialogVideo';
import StackImage from '../../Common/StackImage';
import { ContentTitle, } from '../../Common/TypographyTYH';
import { BoxGridColumnsContainer, BoxGridColumnsFullWidth } from '../../Common/BoxGridColumns';

const EnglishEducation = () => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component EnglishEducation Rendered');

    // TODO: Define useContext
    const context = React.useContext(Context);

    // TODO: Define variable

    // TODO: Define event

    // TODO: Return component
    return (
        <BoxSubPage
            id="EnglishEducation"
            image={Slide}
            title={Text.Top.Menu['LT'].Title[context.language]}
            subtitles={Text.Top.Menu['LT'].Subtitles}
        >
            <Typography sx={{ mb: 1 }}>
                Are you interested in discovering the most up-to-date English news at our school? Dive into Issue 1 of our newspaper!
            </Typography>
            {[1, 2, 3, 4, 5, 6, 7, 8].map(item =>
                <Box
                    component="img"
                    src={`https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/Issue1_0${item}.jpg`}
                    sx={{ mb: 1, width: 1, maxWidth: '600px' }}
                />)}
        </BoxSubPage >
    );
};
export default EnglishEducation;